import { Dictionary } from "../../../util/collection/Dictionary";
/**
 * GameConfig.ts
 */
export class GameConfig {
    constructor() {
    }
    parse(element) {
        this.element = element;
        this.id = element.getAttribute("id");
        this.properties = new Dictionary();
        for (let i = 0; i < element.attributes.length; i++) {
            this.parseAttribute(element.attributes[i]);
        }
    }
    parseAttribute(attribute) {
        let name = attribute.nodeName;
        let value = this.parseValue(attribute.nodeValue);
        this.properties.setValue(name, value);
    }
    parseValue(value) {
        let parsedValue = value;
        if (value == "true") {
            parsedValue = true;
        }
        else if (value == "false") {
            parsedValue = false;
        }
        return parsedValue;
    }
    getProperty(name) {
        return this.properties.getValue(name);
    }
    getId() {
        return this.id;
    }
    setData(element) {
        this.parse(element);
    }
}
//# sourceMappingURL=GameConfig.js.map